var React = require('react');

function SocialLinkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M398.4,0H31.8C14.2,0,0,13.8,0,30.8v368.5c0,17,14.2,30.8,31.8,30.8 h366.6c17.5,0,31.8-13.8,31.8-30.8V30.8C430.1,13.8,415.9,0,398.4,0z M130.4,360h-65V165.8h65V360z M97.9,139.3h-0.4 c-21.8,0-35.9-14.9-35.9-33.6c0-19,14.5-33.5,36.8-33.5c22.2,0,35.9,14.5,36.3,33.5C134.7,124.4,120.6,139.3,97.9,139.3z M364.7,360h-65V256.1c0-26.1-9.4-43.9-32.9-43.9c-18,0-28.6,12-33.3,23.6c-1.7,4.1-2.2,9.9-2.2,15.7V360h-65c0,0,0.9-176,0-194.2 h65v27.5c8.6-13.2,24-32.1,58.5-32.1c42.8,0,74.8,27.7,74.8,87.4L364.7,360L364.7,360z M230.9,194c0.1-0.2,0.3-0.4,0.4-0.6v0.6 H230.9z"}));
}

SocialLinkedin.defaultProps = {"className":"icon-social","version":"1.1","id":"icon-linkedin","x":"0px","y":"0px","viewBox":"0 0 430.1 430.1","style":{"enableBackground":"new 0 0 430.1 430.1"},"xmlSpace":"preserve"};

module.exports = SocialLinkedin;

SocialLinkedin.default = SocialLinkedin;
